import React, { createContext, useEffect, useReducer, useState } from 'react';
import axios from '../../../axios';
import MatxLoading from "../../components/MatxLoading";
import SessionOut from "../../views/sessions/SessionOut";
import useError from "../../hooks/useError";

const initialValue = {
    admins: []
};
const reducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_ADMIN_DATA': {
            return {
                ...state,
                admin_list: action.payload,
            }
        }
        case 'UPDATE_ADMIN_DATA': {
            let newData = state.admin_list.admins.map((admin) =>
                action.payload.id === admin.id ? action.payload : admin
            );

            let newState = {
                admins: newData
            }

            return {
                ...state,
                admin_list: newState,
            }
        }
        case 'UNAUTHORIZED': {
            return {
                ...state,
                status: 401,
            }
        }
        default: {
            return state
        }
    }
}

const AdminContext = createContext({
    admin_list: initialValue,
    getAdmins: () => {},
    getAdmin: () => {},
    addAdmin: () => {},
    updateAdmin: () => {},
    changeStatus: () => {},
})

export const AdminProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, {})
    const { setError } = useError();

    const getAdmins = async () => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/admins/get_admins', options);

            dispatch({
                type: 'LOAD_ADMIN_DATA',
                payload: res.data,
            })
        } catch (e) {
            console.error(e)
            // alert(JSON.stringify(e.response.data));
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
        }
    }

    const getAdmin = async (id) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/admins/get_admin/'+id, options);

            return res.data;
        } catch (e) {
            console.error(e)
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
            return null;
        }
    }

    const addAdmin = async (data) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/json',
                }
            }

            return await axios.post('/api/admins/add_admin', data, options);
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
            return e;
        }
    }

    const updateAdmin = async (data) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/json',
                }
            }

            return await axios.post('/api/admins/update_admin', data, options);
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
            return e;
        }
    }

    const changeStatus = async (id, status) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/json',
                }
            }

            const res = await axios.get(`/api/admins/change_status/${id}/${status}`, options);
            dispatch({
                type: 'UPDATE_ADMIN_DATA',
                payload: res.data,
            })
        } catch (e) {
            if(e.response.status === 401){
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            }else if(e.response.status === 400){
                setError({title: "Error", message: e.response?.data?.message??"Something wrong on server", status: 400})

            }else if(e.response.status === 500){
                setError({title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400})
            }else{
                setError({title: "Network Error", message: "Network error occurred", status: 400})
            }
        }
    }

    useEffect(() => {
        getAdmins();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    if(state.status === 401){
        return <SessionOut />
    }

    if(state.admin_list === undefined) {
        return <MatxLoading />
    }

    return (
        <AdminContext.Provider
            value={{
                admin_list: state.admin_list,
                getAdmins,
                getAdmin,
                addAdmin,
                updateAdmin,
                changeStatus,
            }}
        >
            {children}
        </AdminContext.Provider>
    )
}

export default AdminContext
